import { Box, Paper, Stack } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useTranslation } from 'react-i18next'
import TechInfo from '../../../../components/TechInfo'
import { useSelector } from 'react-redux'
import { getGeneralSettingsInfo } from './utils'
import CardInfoWrapper from './CardInfo/CardInfoWrapper'
import { useState } from 'react'
import QuestionnaireFormDialog from './CardInfo/QuestionnaireFormDialog'
import EditQuestionnaireTemplateDetailsDialog from '../QuestionnaireTemplateDetailDialog'

const QuestionnaireTemplateDetail = () => {
    const { t } = useTranslation()
    const { questionnaireStore: { questionnaireTemplateDetails: { templateDetails } } } = useSelector(state => state);
    const latestVersionNumber = Math.max(...Object.values(templateDetails).map(v => v.version));
    const currentVersionDetails = templateDetails[latestVersionNumber] || {};
    const [isOpenEditIconDialog, setIsOpenEditDialog] = useState({ open: false, tabId: "" })
    const [isOpenSurveyQuestionDialog, setIsOpenSurveyQuestionDialog] = useState(false)

    const handleEditTask = (value) => {
        setIsOpenEditDialog({ open: value ? true : false, tabId: value })
    }

    return (
        <Box
            sx={{
                flexGrow: 1,
                bgcolor: grey[100],
                p: 2,
                overflow: "auto",
                height: "100%",
            }}>
            <Stack sx={{
                flexGrow: 1,
                my: 2,
            }} spacing={2}>

                <Paper sx={{ width: "100%", bgcolor: "common.white" }} elevation={0}>
                    <CardInfoWrapper title={t('taskAutomation.generalSettings')} details={getGeneralSettingsInfo(t)} setIsOpenSurveyQuestionDialog={setIsOpenSurveyQuestionDialog} handleEditTask={handleEditTask} />
                </Paper>

                <Paper sx={{ width: '100%', bgcolor: 'common.white' }} elevation={0} >
                    <TechInfo title={t('general.techInfo')} subtitle={t("general.mutationHistory")} data={currentVersionDetails} />
                </Paper>
            </Stack>

            {
                isOpenEditIconDialog.open && <EditQuestionnaireTemplateDetailsDialog
                    isOpenEditIconDialog={isOpenEditIconDialog}
                    onClose={() => setIsOpenEditDialog(false)}
                />
            }

            {
                isOpenSurveyQuestionDialog && <QuestionnaireFormDialog
                    handleClose={() => setIsOpenSurveyQuestionDialog(false)}
                />
            }
        </Box>
    )
}

export default QuestionnaireTemplateDetail
